import React from 'react';
import { Table } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from '../../../locale/messages';
import { updatePaymentMethod } from "../../../actions/siteadmin/Payout/updatePayout";
import { demoRestriction } from '../../../actions/demoRestriction';
import bt from '../../../components/commonStyle.css';
import s from './PaymentGatewayList.css';

const PaymentGatewayList = ({ getPaymentMethods }) => {

    const dispatch = useDispatch();
    const intl = useIntl();

    const handleChange = async (e, id) => {
        let status = e.target.value == 'true' ? true : false;
        const isRestrict = await dispatch(demoRestriction({}));
        if (isRestrict) return;
        await dispatch(updatePaymentMethod(id, status));
    }

    return (
        <div className={'tableOuterContainer whiteDropdown'}>
            <Table className={'tableContainer'}>
                <thead>
                    <tr>
                        <th scope="col"><FormattedMessage {...messages.id} /></th>
                        <th scope="col"><FormattedMessage {...messages.paymentGateWay} /></th>
                        <th scope="col"><FormattedMessage {...messages.status} /></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        getPaymentMethods && getPaymentMethods.results && getPaymentMethods.results.length > 0 && getPaymentMethods.results.map((item, index) => {
                            let status = item.isEnable ? 'true' : 'false';
                            return (
                                <tr key={index}>
                                    <td data-label={intl.formatMessage(messages.id)}>{item && item.id}</td>
                                    <td data-label={intl.formatMessage(messages.paymentGateWay)}>{item && item.paymentName}</td>
                                    <td data-label={intl.formatMessage(messages.status)}>
                                        <div>
                                            <select name="isEnable" onChange={(e) => handleChange(e, item.id)} className={bt.selectInput} value={status}>
                                                <option value="true">{intl.formatMessage(messages.active)}</option>
                                                <option value="false">{intl.formatMessage(messages.inactive)}</option>
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </Table>
        </div>
    );

}
export default withStyles(bt, s)(PaymentGatewayList);